import { apiRequest } from '../../api/client';

const unwrap = <T>(promise: Promise<{ data: T }>): Promise<T> => promise.then((e) => e.data);

export interface MemberAppLinks {
  androidUrl: string | null;
  iosUrl: string | null;
}

export interface UpdateMemberAppLinksPayload {
  androidUrl: string | null;
  iosUrl: string | null;
  reason: string;
}

export const appLinksKeys = {
  all: ['app-links'] as const,
};

export const appLinksApi = {
  get: () => unwrap(apiRequest<MemberAppLinks>('/admin/app-links')),

  update: (body: UpdateMemberAppLinksPayload) =>
    unwrap(apiRequest<MemberAppLinks>('/admin/app-links', { method: 'PUT', body })),
};
